import React from 'react';
import classes from './PostQueueStatsSet.module.scss';
import { PostQueueStatSizeEnum } from '../../../../components/containers/PostQueueStat/PostQueueStat.view';
import { ProfileMetrics } from '../../../../constants/profileMetrics';
import { mapProfileMetricToIcon } from '../../../../helpers/mapProfileMetricToIcon';
import { PostQueueStat } from '../../../../components/containers/PostQueueStat';
import { ThirdPartyPost } from '../../../../models/graphql';
import { ProfileFindContent } from '../FindContentProvider';

export type PostQueueStatsSetViewProps = {
  availableMetrics: ProfileMetrics[];
  post: ThirdPartyPost;
  selectedProfile: ProfileFindContent;
};

export const PostQueueStatsSetView = ({
  availableMetrics,
  post,
  selectedProfile
}: PostQueueStatsSetViewProps): JSX.Element => {
  const queueStatsSet = availableMetrics.map(metric => {
    if (metric === ProfileMetrics.likes || metric === ProfileMetrics.shares || metric === ProfileMetrics.comments) {
      const icon = mapProfileMetricToIcon(selectedProfile?.__typename, metric);

      // If icon does not return an icon, to proceed
      if (!icon) return null;

      return (
        <div key={metric} className={classes.PostQueueStatWrapper}>
          <PostQueueStat
            label={icon}
            showBarGraph={false}
            value={post[metric] || 0}
            hideLabel={true}
            size={PostQueueStatSizeEnum.MEDIUM}
          />
        </div>
      );
    } else {
      return null;
    }
  });

  return <div>{queueStatsSet}</div>;
};
